module.exports = __webpack_public_path__ + "img/palette-2-fg_en.d403432.jpg";